import 'includes/jquery';
import 'includes/tether';
import 'includes/popper';

import 'bootstrap';



// WEBPACK FOOTER //
// ./src/includes/bootstrap.js